// src/components/SearchBar.tsx

import React from 'react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  placeholder?: string;
  loading: boolean;
  rightSlot?: React.ReactNode;   // ← ★ Dropdownなどを注入可能
  prompt?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  onSearch,
  placeholder = "キーワードを入力",
  loading,
  rightSlot,
  prompt
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch();
  };

  return (
  <div className="bg-white px-6 py-4 shadow-none border-none">
    {prompt && (
      <div className="mx-auto mb-10 mt-10 max-w-3xl text-center">
        <h1 className="text-xl font-medium tracking-normal text-slate-500 sm:text-2xl">
          {prompt}
        </h1>
      </div>
    )}
    
    {/* ← 横並びコンテナ */}
    <div className="flex gap-2 w-full max-w-3xl mx-auto items-center">
      
      {/* ← フォームは input + button のみ */}
      <form
        onSubmit={handleSubmit}
        className="flex gap-2 flex-1 items-center"
      >
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="flex-1 px-4 py-2 border border-gray-300 rounded shadow-sm 
                     focus:outline-none focus:ring-2 focus:ring-blue-500"
        />

        <button
          type="submit"
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
        >
          {loading ? '分析中...' : '分析する'}
        </button>
      </form>

      {/* Dropdown（フォームの外だが横並び） */}
      {rightSlot && (
        <div className="shrink-0">
          {rightSlot}
        </div>
      )}

    </div>
  </div>
);

};

export default SearchBar;
